var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chat_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.333 6.333v44.334h9.917v8.853l14.313-8.853h27.104V6.333zm35 19.834h-21v-7h21zm-21 11.666h16.334v-7H20.333z",
    clipRule: "evenodd"
  })));
};
export { SvgChat as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMzMzMzQgNi4zMzMzN1Y1MC42NjY3SDE2LjI1VjU5LjUyMDNMMzAuNTYzNCA1MC42NjY3SDU3LjY2NjdWNi4zMzMzN0g2LjMzMzM0Wk00MS4zMzMzIDI2LjE2NjdIMjAuMzMzM1YxOS4xNjY3SDQxLjMzMzNWMjYuMTY2N1pNMjAuMzMzMyAzNy44MzM0SDM2LjY2NjdWMzAuODMzNEgyMC4zMzMzVjM3LjgzMzRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";